export const useCostFormatting = () => {
    const formatCurrency = (amount: number): string => {
        return new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount)
    }

    const formatCurrencyCompact = (amount: number): string => {
        if (amount >= 1000000) {
            return `$${(amount / 1000000).toFixed(1)}M`
        } else if (amount >= 1000) {
            return `$${(amount / 1000).toFixed(1)}K`
        }
        return formatCurrency(amount)
    }

    const getCostColor = (cost: number, thresholds: { low: number, high: number }): string => {
        if (cost < thresholds.low) return 'text-green-600 dark:text-green-400'
        if (cost < thresholds.high) return 'text-yellow-600 dark:text-yellow-400'
        return 'text-red-600 dark:text-red-400'
    }

    const getCostBgColor = (cost: number, thresholds: { low: number, high: number }): string => {
        if (cost < thresholds.low) return 'bg-green-100 dark:bg-green-500/20'
        if (cost < thresholds.high) return 'bg-yellow-100 dark:bg-yellow-500/20'
        return 'bg-red-100 dark:bg-red-500/20'
    }

    const formatPercentChange = (change: number): string => {
        const sign = change >= 0 ? '+' : ''
        return `${sign}${change.toFixed(1)}%`
    }

    const getTrendIcon = (trend: 'up' | 'down' | 'stable'): string => {
        if (trend === 'up') return '↑'
        if (trend === 'down') return '↓'
        return '→'
    }

    const formatRelativeTime = (timestamp: string): string => {
        const now = new Date()
        const then = new Date(timestamp)
        const diffMs = now.getTime() - then.getTime()
        const diffMins = Math.floor(diffMs / 60000)
        const diffHours = Math.floor(diffMs / 3600000)
        const diffDays = Math.floor(diffMs / 86400000)

        if (diffMins < 60) return `${diffMins} minutes ago`
        if (diffHours < 24) return `${diffHours} hours ago`
        return `${diffDays} days ago`
    }

    return {
        formatCurrency,
        formatCurrencyCompact,
        getCostColor,
        getCostBgColor,
        formatPercentChange,
        getTrendIcon,
        formatRelativeTime
    }
}
